import { render, staticRenderFns } from "./AdministrativePermitsMenuItem.vue?vue&type=template&id=015c8f3a"
import script from "./AdministrativePermitsMenuItem.vue?vue&type=script&lang=js"
export * from "./AdministrativePermitsMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports